import { computed, type ComputedRef } from "vue";
import { Channel, type PlayItem } from "@ca.vmedia.tv/domains";
import type { PlayItemRestrictionsProcessor } from "@/components/Player/types/PlayItemRestrictionsProcessor";


interface ExposeInterface {
    description: ComputedRef<string>;
}

export const useGetDescription = (item: PlayItem | PlayItemRestrictionsProcessor | Channel | null): ExposeInterface => {
    const description = computed((): string => {
        if (item instanceof Channel) {
            return item?.description || ""
        }
        return item?.seriesDescription || item?.seasonDescription || item?.description || item?.shortDescription || ""
    });

    return <ExposeInterface> {
        description
    }
};
